export default "__VITE_ASSET__CTkzDgxS__"